<template>
  <div class="page-card info-page">
    <div class="info-form">
      <!-- 头像上传 -->
      <div class="form-row avatar-row">
        <div class="avatar-preview">
          <img v-if="avatarUrl" :src="avatarUrl" class="avatar-img" />
          <a-avatar v-else class="user-avatar">{{ nickName?.slice(0, 1) }}</a-avatar>
        </div>
        <div class="upload-tip">
          <a-upload
            name="avatar"
            accept="image/*"
            :show-upload-list="false"
            :before-upload="beforeUpload"
          >
            <a-button>上传头像</a-button>
          </a-upload>
          <p class="tip-text">支持PNG、JPG，大小不超过2M</p>
        </div>
      </div>

      <!-- 昵称 -->
      <div class="form-row">
        <label class="form-label">昵称</label>
        <a-input v-model:value="form.nickName" :maxlength="20" show-count />
      </div>

      <!-- 手机号 -->
      <div class="form-row">
        <label class="form-label">手机号</label>
        <a-input v-model:value="form.phone" disabled />
      </div>

      <a-button type="primary" class="save-btn" @click="handleSave">保存</a-button>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
import { updateMyProfile, getUserInfo } from '../../api/personal/user'
const props = defineProps(['userInfo'])
const emit = defineEmits(['save-info', 'upload-avatar'])
const saving = ref(false)
const avatarUrl = ref('')
const selectedFile = ref(null)

// 从 localStorage 获取用户信息
const fetchUserProfile = () => {
  try {
    const response = JSON.parse(localStorage.getItem('user'))
    return response
  } catch (error) {
    console.error('获取用户信息失败:', error)
    return {}
  }
}
const userData = fetchUserProfile()

// 头像：优先 headImgFile（完整 URL），其次 headImgs[0]
avatarUrl.value = typeof userData.headImgFile === 'string' ? userData.headImgFile.trim() : ''
if (!avatarUrl.value) {
  const headImgList = userData.headImgs || []
  avatarUrl.value = (headImgList.length > 0 && typeof headImgList[0] === 'string') ? headImgList[0].trim() : ''
}
// 昵称
const nickName = userData.nickName || userData.name || ''

// 本地表单副本，不污染父组件数据
const form = reactive({
  nickName: nickName,
  phone: userData.phone || props.userInfo?.phone || ''
})

// 头像上传
const beforeUpload = (file) => {
  const isImage = file.type.startsWith('image/')
  if (!isImage) {
    message.error('只能上传图片文件')
    return false
  }
  // 生成本地预览
  avatarUrl.value = URL.createObjectURL(file)
  selectedFile.value = file
  emit('upload-avatar', file)
  return false
}

// 保存提交
const handleSave = async () => {
  if (saving.value) return
  saving.value = true
  try {
    const formData = new FormData()
    formData.append('nickName', form.nickName)
    formData.append('headImgFile', selectedFile.value || '')
    await updateMyProfile(formData)
    message.success('保存成功')
    // 重新获取用户信息并更新 localStorage
    const userRes = await getUserInfo()
    if (userRes.code === 200) {
      localStorage.setItem('user', JSON.stringify(userRes.data))
      window.dispatchEvent(new Event('user-updated'))
    }
    emit('save-info', { ...form })
  } catch (err) {
    message.error('保存失败：' + (err.message || '未知错误'))
  } finally {
    saving.value = false
  }
}
</script>

<style scoped lang="less">
.page-card {
  background: #F7F8FA;
  border-radius: 0 0 12px;
  padding: 28px;
  min-height: 820px;
  border: 34px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
//   margin: 0 auto;
//   max-width: 600px;
}
.info-form {
  background-color: #fff;
  min-width: 820px;
//   min-height: 420px;
  padding: 24px;
  .avatar-row {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 24px;
    .avatar-preview {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      .avatar-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
      .user-avatar {
        width: 80px !important;
        height: 80px !important;
        line-height: 80px !important;
        font-size: 32px;
        flex-shrink: 0;
      }
    }
    .upload-tip {
      .tip-text {
        font-size: 13px;
        color: #8c8c8c;
        margin: 0;
      }
    }
  }
  .form-row {
    margin-bottom: 20px;
    .form-label {
      display: block;
      font-size: 14px;
      color: #333;
      margin-bottom: 8px;
    }
  }
  .save-btn {
    margin-top: 10px;
  }
}
</style>